/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2021-2024 (original work) Open Assessment Technologies SA
 *
 */

const SESSION_STORAGE_KEY = 'tao-portal-session-';

const getItemKey = key => `${SESSION_STORAGE_KEY}${key}`;

/**
 * Returns the item from session storage
 *
 * @param {string} key
 * @returns {string | Object} item
 */
export const getItem = key => JSON.parse(window.sessionStorage.getItem(getItemKey(key)));

/**
 * Remove the item from session storage
 * @param {string} key
 */
export const removeItem = key => {
    window.sessionStorage.removeItem(getItemKey(key));
};

/**
 * Set item in session storage
 * @param {string} key
 * @param {string | Object} item
 */
export const setItem = (key, item) => {
    window.sessionStorage.setItem(getItemKey(key), JSON.stringify(item));
};
